import router from "@/router";
import store from "@/store/index"
import { Message } from "element-ui";
import { eventBus } from "@/utils/helper/eventBus";
import { callHelper } from "@/utils/helper/caller.helper";
import { agentCallOut, queryJobOrderIdByAgentId, callRecordBindQywx } from "@/api/interface/cti";
import { getWorkOrderList, getCallInCount } from "@/api/interface/customer";
import { getIdByCallId } from "@/api/interface/weChatApi";

// 话务相关状态及事件回调
class CallerWindowState {
  isCalling = false;
  muting = false; //是否呼叫保持(即静默用户)
  callRe = null;
  ctiStatus = "";
  autoDialStateDesc = false
  autoDialCount = 0
  callWindowStatus = ""; // ON_RING, ON_CALLING, ON_MAKE_CALL, ON_WAITING
  currentTime = 0;
  callerWaitPopVisible = false
  callerWaitPopVisibleType = 2
  // callerWaitPopVisibleType = 2
  onRingingParams = {};
  showInComingDrawer = false;
  customerIncomingDetails = {};
  callInCount = 0
  currentCallCustomerRealName = "";
  currentCallCusId = "";  //当前外呼客户的 customerId  / 工单ID
  customerCallFail = false;
  lastTelSaleState = 0;   //通话阶段状态 2 未接通； 12 已接通
  convId = "" // 转人节点
  callId = ""
  hangupCallId = "";  //刚挂断时的callId
  callSuccess = false;  //是否双方接通

  constructor(props) {
    eventBus.$on("onRegisterSuccess", this.onRegisterSuccess.bind(this)); //注册成功
    eventBus.$on("onUnregisteredSuccess", this.onUnregisteredSuccess.bind(this)); //注销成功
    eventBus.$on("hangup", this.onHangup.bind(this));
    eventBus.$on("ring", this.onRing.bind(this));
    eventBus.$on("callAnswer", this.onCallAnswer.bind(this));
    eventBus.$on("fail", this.onFail.bind(this));
    eventBus.$on("ringing", this.onRinging.bind(this));
    eventBus.$on("agentSipLink", this.onAgentSipLink.bind(this));
    eventBus.$on("refuse", this.onRefuse.bind(this));
    eventBus.$on("finishCall", this.finishCall.bind(this))
    eventBus.$on("logOut", this.onLogOut.bind(this))
    eventBus.$on("phoneRingOutbound", this.phoneRingOutbound.bind(this));
    eventBus.$on("startAutoDial", this.startAutoDial.bind(this))
    eventBus.$on("closeAutoDial", this.closeAutoDial.bind(this));
    eventBus.$on("setCallSuccess", this.setCallSuccess.bind(this));
    eventBus.$on("onPreviewOutcallBridgeBusyOb", this.onPreviewOutcallBridgeBusyOb.bind(this));
    this.refuse = this.refuse.bind(this);
  }
  // 更新状态
  setCallWindowStatus(value){this.callWindowStatus = value;}
  setCallSuccess(flag){this.callSuccess = flag;}
  // 开始话务计时
  startCurrentCalling() {
    if (this.callRe) window.clearInterval(this.callRe)
    this.callRe = setInterval(() => {
      this.currentTime = this.currentTime + 1;
    }, 1000);
  }
  // 监听-挂断
  onHangup(event) {
    console.log('onHangup =>', event, {...this});
    // const {outCallList, lusUserCti} = store.state.global;
    callRecordBindQywx({callId: this.hangupCallId});
    const {onRingingParams, callRe} = this;
    const {callType} = onRingingParams;
    this.muting = false;
    this.callId = ""
    this.convId = ""
    this.isCalling = false;
    this.callInCount = 0

    if (callRe) window.clearInterval(callRe);
    this.showInComingDrawer = false;

    // 关闭loading
    if (callHelper.setupMsgIns) {
      callHelper.setupMsgIns.close()
      clearTimeout(callHelper.setupMsgInsTimeout)
    }

    if (callType == 1) {
      this.onRingingParams = {callType};
    } else {
      this.customerIncomingDetails = {};
    }

    setTimeout(() => {
      this.callWindowStatus = "ON_WAITING";
      this.showIncommingDrawer = false;
      this.currentTime = 0;
      eventBus.$emit("clearAgentSipLinkCallId", '');
    }, 300)
  }
  // 监听-坐席呼出（只有呼出触发）
  onRing(event) {
    console.log('onRing =>', event, {...this});
    const {params} = event;
    if (params.clid) this.onRingingParams.clid = params.clid;
    const callId = params.instanceId || params.mainUniqueId;
    const jobOrderId = params.jobOrderId || params.customerId;

    this.callWindowStatus = "ON_RING";
    this.currentTime = 0;
    this.showInComingDrawer = false;
    this.startCurrentCalling();
    if (callHelper.setupMsgIns) callHelper.setupMsgIns.close(); //关闭loading
    if (!callId) return;

    agentCallOut({
      callId,
      jobOrderId,
      type: 0,
      // type: "CALL_OUT"
    }).then(res => {
      callHelper.setCallId(res.id);
    })
  }
  // 外呼双方接通-通话中回调
  onPreviewOutcallBridgeBusyOb(event){
    // 播放敲门声
    const audio = document.querySelector('#huawuDoor');
    if (audio) audio.play();
  }
  // 监听-坐席外呼接通
  onCallAnswer(event) {
    console.log('onCallAnswer =>', event);
    this.setCallSuccess(true);
    this.callWindowStatus = "ON_CALLING";
    this.currentTime = 0;
    this.startCurrentCalling();
    if (callHelper.setupMsgIns) callHelper.setupMsgIns.close(); //关闭loading
    setTimeout(() => {this.showInComingDrawer = false;}, 300);  //关闭来电响铃弹窗
  }
  // 监听-失败
  onFail(event) {
    console.warn('---- fail ----', event);
    this.isCalling = false;
    if (event.errMsg !== "呼叫系统尚未初始化完成") {
      if (store.state.global.lusUserCti.autoDial) {
        this.customerCallFail = true
        agentCallOut({
          callId: event.callId,
          jobOrderId: event.jobOrderId || event.customerId,
          type: 0,
        })
        callHelper.hangup();
        this.onHangup();
      }
    }
    if (callHelper.setupMsgIns) callHelper.setupMsgIns.close();
  }
  // 响铃回调 (呼入、呼出都会触发)
  onRinging(event) {
    console.log('onRinging =>', event, {...this});
    const {params} = event;
    this.onRingingParams = params;
    const {callType, customerNumber, cno} = params;
    const callId = params.mainUniqueId || params.instanceId;
    if (callId) this.hangupCallId = callId;
    // 状态重置
    this.setCallSuccess(false);
    sessionStorage.removeItem('noJobOrderId');

    // 天润
    if (callType == 1) {
      if (customerNumber && cno){
        this.showInComingDrawer = true;
        this.customerIncomingDetails.phone = customerNumber;
        getWorkOrderList({
          "page": 1,
          "size": 20,
          "phone": customerNumber,
          "complaintStatus": [
            0,
            1
          ]
        }).then(res => {
          if (Array.isArray(res.data.list) && res.data.list.length > 0) {
            agentCallOut({
              callId,
              jobOrderId: res.data.list[0].id,
              type: 1,
            }).then(r => {})
          } else {
            getIdByCallId({
              callId,
              type: 1,
            }).then(res => {
              if (res.code == "000000") {
                if (res.data) {
                  agentCallOut({
                    callId,
                    jobOrderId: res.data,
                    type: 1,
                  }).then(r => {})
                }
              }
            })
          }
        })
      }
    } else if (callType == 4){
      if (customerNumber && cno){
        // this.showInComingDrawer = true;
        this.customerIncomingDetails.phone = customerNumber;
      }
    }

    // hnzj
    if (params.customerId) {
      this.currentCallCustomerRealName = params.customerName;
      this.currentCallCusId = params.customerId;
      this.showInComingDrawer = true;
      this.customerIncomingDetails.city = "";
      this.customerIncomingDetails.name = this.currentCallCustomerRealName;
      this.customerIncomingDetails.phone = params.customerNumber;
      getCallInCount({
          phone: params.customerNumber
      }).then(res=> {
          if (res.code === "000000") {
              this.callInCount = res.data
          }
      })
    }
  }
  onAgentSipLink(event) {
    console.log('onAgentSipLink', event, {...this});
    const {onRingingParams, callWindowStatus} = this;
    const {callType, customerNumber, cno} = onRingingParams;
    const {origin} = event;
    const callId = event.callId || event.instanceId;
     // const {outCallList, lusUserCti} = store.state.global;

    // 关闭loading
    if (callHelper.setupMsgIns) {
      callHelper.setupMsgIns.close()
      clearTimeout(callHelper.setupMsgInsTimeout)
    }

    // 如果不在投诉工单页，就跳过去
    if (!window.location.pathname.match("/customer/work-order-list")) {
      router.push({path: "/customer/work-order-list"})
    }

    setTimeout(() => {
      if (callWindowStatus === "ON_RING" || callWindowStatus === "ON_CALLING") {
        Message.error("请完成当前通话！");
        return
      }
      if (callId) {
        this.setCallSuccess(true);
        eventBus.$emit("getAgentSipLinkCallId", callId);
      }

      // 黑牛自建
      if (origin === 'hnzj'){
        this.onCallAnswer(event);
        return;
      }

      // 天润
      if (customerNumber && cno) {
        if (callType == 1) {
          this.onCallAnswer(event);
        }
      }
    }, 500)
  }
  onRefuse(event) {

  }
  finishCall(event) {

  }
  // 退出登录回调
  onLogOut(flag) {
    this.onUnregisteredSuccess(flag)
  }
  phoneRingOutbound(event) {

  }
  // 开始自动外呼调下一个
  startAutoDial() {
    // 如果不在投诉工单页，就跳过去
    if (!window.location.pathname.match("/customer/work-order-list")) {
      router.push({path: "/customer/work-order-list"})
    }

    if (this.customerCallFail) {
      this.customerCallFail = false
      this.callWindowStatus = '';
    }

    setTimeout(() => {
      queryJobOrderIdByAgentId({}).then(res => {
        if (res.code !== '000000') return;
        if (res.data) {
          this.autoDialCount = 0
          clearInterval(window.autoDialCountTimer)
          this.autoDialStateDesc = true
          eventBus.$emit("getAgentAutoDialWorkOrder", res.data)
        } else {
          if (store.state.global.lusUserCti.autoDial) {
            clearInterval(window.autoDialCountTimer)
            window.autoDialCountTimer = setInterval(() => {
              this.autoDialCount ++
              if (this.autoDialCount % 60 === 0) {
                this.startAutoDial()
              }
            }, 1000)
          } else {
            this.closeAutoDial()
            Message.error("暂无可拨打的工单，已为您关闭自动拨号功能！")
          }
        }
      })
    }, 500)
  }
  // 关闭自动外呼
  closeAutoDial() {
    this.autoDialCount = 0
    clearInterval(window.autoDialCountTimer)
    this.customerCallFail = false
    this.autoDialStateDesc = false
  }
  // 挂断
  hangup() {
    callHelper.hangup();
  }
  // 拒接
  refuse() {
    callHelper.refuse();
    this.showInComingDrawer = false;
    this.hangup();
  }
  // 来电
  sipLink() {
    callHelper.sipLink();
  }
  // 呼叫保持，通话时坐席操作呼叫保持后，用户端收听背景音，坐席可以与其他人讲话（用户听不到坐席侧的声音）
  mute() {
    callHelper.holdCall();
  }
  // 取消呼叫保持，保持中的通话，坐席可以取消呼叫保持，取消后，用户端恢复与坐席正常的双向通话（彼此听到对方声音）
  unMute() {
    callHelper.unHold();
  }
  // 注册成功回调
	onRegisterSuccess(event){
    // this.callerWaitPopVisibleType = 2;
    // this.callerWaitPopVisible = true;

    if (window.fsLogoutTimer) clearTimeout(window.fsLogoutTimer);
    if (window.fsLogoutTimer2) clearTimeout(window.fsLogoutTimer2);

    // 注册 N 小时后自动退出话务登录
    window.fsLogoutTimer = setTimeout(() => {
      callHelper.logOut();
    }, 1000 * 3600 * 12);

    this.fsAutoLogoutFromDeadTime();
  }
  // 注销成功回调
  onUnregisteredSuccess(flag){
    // if (flag) this.callerWaitPopVisibleType = 1;
    // this.callerWaitPopVisible = false
  }
  // 超过截止时间后自动退出话务登录
  fsAutoLogoutFromDeadTime(){
    const diffTime = Date.now() - new Date().setHours(23, 40, 0);
    if (diffTime > 0){
      callHelper.logOut();
      return;
    }
    window.fsLogoutTimer2 = setTimeout(() => {
      this.fsAutoLogoutFromDeadTime();
    }, 1000*60*10);
  }
}

export const callerWindowState = new CallerWindowState()
